import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const TrashFilledIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M9 6H15V7V8H18V9H16V17H8V9H6V8H9V7V6ZM10 7H14V8H10V7Z" fill={fillColor || '#111112'} />
    </svg>
  );
};

export { TrashFilledIcon };
